import type { SplitName, SplitTreatments } from '@/constants/splits'
import { fetchTreatments } from '@/services/splitTreatments'
import { useQuery } from '@tanstack/react-query'

type SplitAttributes = Record<string, string | number | boolean | undefined>

const NO_TREATMENTS: SplitTreatments = {}

export const useSplitTreatments = ({
  attributes,
  names,
}: {
  attributes: SplitAttributes
  names: readonly SplitName[]
}): SplitTreatments => {
  const definedAttributes = Object.fromEntries(
    Object.entries(attributes).filter(([, value]) => value !== undefined && value !== '')
  )

  const { data } = useQuery({
    queryKey: ['splitTreatments', names, definedAttributes],
    queryFn: async (): Promise<SplitTreatments> => fetchTreatments(names, definedAttributes),
  })

  return data ?? NO_TREATMENTS
}
